import $ from 'jquery'

export interface ScriptContent {
  src: string
  body: string
}

export default function findScripts(html: string): ScriptContent[] {
  const scripts: ScriptContent[] = []
  $(`<div>${html}</div>`).find('script').each(function () {
    const $script = $(this)
    scripts.push({
      src: $script.attr('src'),
      body: $script.html()
    })
  })
  return scripts
}
